/**
 * API клієнт для doc.loyalty_transactions (Порція Роздріб.3/5a).
 * Backend: /api/v1/retail/loyalty-transactions.
 *
 * Permissions: розщеплено по transaction_type (OR-logic на backend).
 *  - accrual → retail.loyalty.accrue ABO retail.customer_card.manage
 *  - writeoff → retail.loyalty.writeoff ABO retail.customer_card.manage
 *
 * Створення з POST flow retail_sales — внутрішнє (reason='sale'/'sale_payment'),
 * не через цей endpoint.
 */
import { api } from './client';
import type { Page } from './catalogs';

export type LoyaltyTransactionType = 'accrual' | 'writeoff';

export interface LoyaltyTransaction {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  transaction_type: LoyaltyTransactionType;
  customer_card_id: string;
  amount: string;
  reason: string;
  source_sale_id: string | null;
  source_return_id: string | null;
  accrual_percent: string | null;
  base_amount: string | null;
  balance_before: string;
  balance_after: string;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface LoyaltyTransactionCreate {
  organization_id: string;
  document_number?: string | null;
  document_date?: string | null;
  transaction_type: LoyaltyTransactionType;
  customer_card_id: string;
  amount: string;
  reason: string;
  comment?: string | null;
}

export interface LoyaltyTransactionUpdate {
  comment?: string | null;
}

export const retailLoyaltyTransactions = {
  list: (params?: {
    organization_id?: string;
    customer_card_id?: string;
    transaction_type?: LoyaltyTransactionType;
    posted?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<LoyaltyTransaction>>('/retail/loyalty-transactions', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<LoyaltyTransaction>(`/retail/loyalty-transactions/${id}`).then((r) => r.data),
  create: (payload: LoyaltyTransactionCreate) =>
    api.post<LoyaltyTransaction>('/retail/loyalty-transactions', payload).then((r) => r.data),
  update: (id: string, payload: LoyaltyTransactionUpdate) =>
    api.patch<LoyaltyTransaction>(`/retail/loyalty-transactions/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/retail/loyalty-transactions/${id}`).then(() => undefined),
};
